export type Visibility =
  | 'open_to_all'
  | 'members_only'
  | 'paid'
  | 'subscription';

export default class EpisodeConfig {
  constructor(public enabledZoom: boolean, public visibility: Visibility) {}
}
